<template>
    <b-collapse :visible="showGraph" id="content">
        <card>
            <div slot="header" class="row align-items-center">
                <div class="col">
                    <h5 class="h3 mb-0">Payer Performance</h5>
                </div>
            </div>
            <div class="overflow-auto">
                <b-pagination v-model="currentPage"
                              :total-rows="rows"
                              :per-page="perPage"
                              aria-controls="payerPerformanceTable">
                </b-pagination>
                <b-table id="payerPerformanceTable"
                         :items="tableData"
                         :fields="tableColumns"
                         :per-page="perPage"
                         :current-page="currentPage"
                         small
                         striped>
                </b-table>
            </div>
        </card>
    </b-collapse>
</template>

<script>

    export default {
        name: 'payer-performance-charts',
        props: {
            BIN: String,
            PCN: String,
            GroupNumber: String,
        },
        data() {
            return {
                showGraph: true,
                tableColumns: [
                    { key: 'drug', sortable: true },
                    { key: 'prescriber', sortable: true },
                    { key: 'status', sortable: true },
                    { key: 'rejectioncodes',label: 'rejection codes', sortable: true }
                ],
                perPage: 10,
                currentPage: 1,
                tableData: [],
            };
        },
        methods: {
            fetchData() {
                this.axios.get(`CompanyStats/GetPayerPerformance/${this.BIN}/${this.PCN}/${this.GroupNumber}`)
                    .then(response => {
                            this.tableData = response.data.map(d => {
                                return {
                                    drug: d.drugName,
                                    prescriber: d.prescriberName,
                                    status: d.statusName,
                                    rejectioncodes: d.rejectionCodes.replace('{', '').replace('}','')
                                };
                            })
                        })
                        .catch(error => {
                            
                        });
            },

        },
        watch: {
            BIN: function () {
                this.fetchData()
            }
        },
        computed: {
            rows() {
                return this.tableData.length
            }
        },
        mounted() {
            //this.fetchData();
        }
    }
</script>

<style scoped>
</style>